import Profissional from "../models/Profissional";

export default class Certificado {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.local = "Base da Netech - Mossoró-RN";
    this.pedido = "";
    this.ordem = "";
    this.documento = "";
    this.procedimento = "";
    this.resultado = "APROVADO";
    this.proxima = new Date();
    this.observacao = "";
    this.itens = [];
    this.validade = 12;
    this.inspetor = new Profissional();
    this.responsavel = new Profissional();
  }

  update(certificado) {
    this.numero = certificado.numero;
    this.data = certificado.data;
    this.local = certificado.local;
    this.pedido = certificado.pedido;
    this.ordem = certificado.ordem;
    this.documento = certificado.documento;
    this.procedimento = certificado.procedimento;
    this.resultado = certificado.resultado;
    this.proxima = certificado.proxima;
    this.observacao = certificado.observacao;
    this.itens = certificado.itens;
    this.validade = certificado.validade;
    this.inspetor = certificado.inspetor;
    this.responsavel = certificado.responsavel;
  }
}
